/* Avastar: los simbolos de marca (R y TM) que vienen de las descripciones de producto
   llegan como caracteres sueltos, sin etiqueta, asi que se ven del mismo cuerpo que el
   texto. Este script los envuelve en <sup class="ava-reg"> para que queden en superindice
   reducido, igual que los del tema. Solo recorre contenido rico, nunca atributos ni
   scripts, y salta los que ya estan dentro de un <sup>. Tambien cubre lo que el cliente
   edite en el futuro desde el admin.

   v2 (13-oct-2026): ademas evita que las palabras cortas con guion se partan al final de
   una linea ("omega-" arriba y "3)" solo abajo). Cada palabra con guion de hasta 24
   caracteres (omega-3, D3-K2, GLP-1, BPC-157, CJC-1295, Pre-Dosed...) va en un
   <span class="ava-nb"> con white-space: nowrap, asi pasa entera a la linea siguiente.
   Si el texto esta suelto dentro de un contenedor flex o grid, todo el texto va en un solo
   <span class="ava-wrap">: asi sigue siendo un unico elemento del flex y no se rompe el
   diseno (lo que paso con el TM). Hasta 24 caracteres; los nombres quimicos mas largos
   si pueden cortarse en el guion. */
(function () {
  var RAIZ = 'body';
  var MARCAS = /[®™]/;
  var GUION = /[A-Za-z0-9₀-₉]+(?:-[A-Za-z0-9₀-₉]+)+/g;
  var MAX_GUION = 24;

  function esFlex(el) {
    var d = window.getComputedStyle(el).display;
    return d.indexOf('flex') !== -1 || d.indexOf('grid') !== -1;
  }

  function procesar(raiz) {
    var caminante = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode: function (nodo) {
        var v = nodo.nodeValue;
        GUION.lastIndex = 0;
        if (!MARCAS.test(v) && !GUION.test(v)) return NodeFilter.FILTER_REJECT;
        var padre = nodo.parentElement;
        if (!padre || padre.closest('sup, script, style, textarea, code, pre, svg, title, .ava-nb, input, select, option')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodos = [];
    var actual;
    while ((actual = caminante.nextNode())) nodos.push(actual);

    nodos.forEach(function (texto) {
      var padre = texto.parentNode;
      if (!padre) return;
      var enFlex = esFlex(padre);
      var partes = [];
      /* primero se separan las marcas; luego, en cada trozo de texto, las palabras con guion */
      texto.nodeValue.split(/([®™])/).forEach(function (parte) {
        if (!parte) return;
        if (parte === '®' || parte === '™') { partes.push({ sup: parte }); return; }
        var ultimo = 0, m;
        GUION.lastIndex = 0;
        while ((m = GUION.exec(parte))) {
          if (m[0].length > MAX_GUION) continue;
          if (m.index > ultimo) partes.push({ txt: parte.slice(ultimo, m.index) });
          partes.push({ nb: m[0] });
          ultimo = m.index + m[0].length;
        }
        if (ultimo < parte.length) partes.push({ txt: parte.slice(ultimo) });
      });
      /* si no hay nada que cambiar, no se toca el nodo */
      if (!partes.some(function (p) { return p.sup || p.nb; })) return;
      var fragmento = document.createDocumentFragment();
      partes.forEach(function (p) {
        if (p.sup) {
          var sup = document.createElement('sup');
          sup.className = 'ava-reg';
          sup.textContent = p.sup;
          fragmento.appendChild(sup);
        } else if (p.nb) {
          var span = document.createElement('span');
          span.className = 'ava-nb';
          span.style.whiteSpace = 'nowrap';
          span.textContent = p.nb;
          fragmento.appendChild(span);
        } else {
          fragmento.appendChild(document.createTextNode(p.txt));
        }
      });
      if (enFlex) {
        /* dentro de un flex o grid todo va en UN solo span: sigue siendo un unico elemento del
           flex (como el texto suelto de antes) y el sup o las palabras con guion no se separan */
        var envoltorio = document.createElement('span');
        envoltorio.className = 'ava-wrap';
        envoltorio.appendChild(fragmento);
        fragmento = envoltorio;
      }
      padre.replaceChild(fragmento, texto);
    });
  }

  function ejecutar() {
    try {
      procesar(document.querySelector(RAIZ) || document.body);
    } catch (e) {
      /* si algo falla, el texto se queda como estaba: nunca rompe la pagina */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ejecutar);
  } else {
    ejecutar();
  }
})();
